module.exports = __webpack_public_path__ + "static/media/moderator-wrong-answer.8ea6baff.gif";